import React, { useEffect } from 'react';
import { MUIDataTable, MUIDataTableColumnDef, TableActionTypes, useDataTable } from 'web-library';
import { useParams } from 'react-router-dom';
import { TFunction, useTranslation } from 'react-i18next';
import { usePostGroupRankingDetails } from '../../../api-refactored/group-special-consideration/usePostGroupRankingDetails';

const tableColumns = (t: TFunction<'translation'>): MUIDataTableColumnDef[] => [
  {
    name: 'indexNo',
    label: t('specialConsideration->>TableColumn.IndexNo'),
    options: {
      setCellProps: () => ({
        style: { width: '20%' },
      }),
      customBodyRender: (value: any) => value ?? '-',
    },
  },
  {
    name: 'uniFinPassport',
    label: t('specialConsideration->>TableColumn.UniFinPassport'),
    options: {
      setCellProps: () => ({
        style: { width: '20%' },
      }),
    },
  },
  {
    name: 'candidateName',
    label: t('specialConsideration->>TableColumn.CandidateName'),
    options: {
      setCellProps: () => ({
        style: { width: '20%' },
      }),
      customBodyRender: (value: any) => value ?? '-',
    },
  },
  {
    name: 'prelimGradeMarks',
    label: t('specialConsideration->>TableColumn.Prelim'),
    options: {
      setCellProps: () => ({
        style: { width: '20%' },
      }),
      customBodyRender: (value: any) => value ?? '-',
    },
  },
  {
    name: 'affected',
    label: t('specialConsideration->>TableColumn.Affected'),
    options: {
      setCellProps: () => ({
        style: { width: '20%' },
      }),
      customBodyRender: (value: any) => (value ? 'Affected' : '-'),
    },
  },
];

const GroupRankingDetailsTable = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const { t } = useTranslation();

  const { state: tableState, dispatch: tableDispatch, tOptions: tableOptions } = useDataTable();

  const { mutate: postGroupRankingDetails, isLoading } = usePostGroupRankingDetails({
    uuid,
    onSuccess: (data) =>
      tableDispatch({
        type: 'UPDATE_DATA',
        payload: {
          data: data.content,
          count: data.totalElements,
        },
      } as TableActionTypes),
  });

  useEffect(() => {
    postGroupRankingDetails({
      page: tableState.page,
      pageSize: tableState.size,
    });
  }, [tableState.page, tableState.size, postGroupRankingDetails]);

  return (
    <MUIDataTable
      state={tableState}
      dispatch={tableDispatch}
      columns={tableColumns(t)}
      data={tableState.data}
      isLoading={isLoading}
      options={{
        ...tableOptions,
        pagination: true,
      }}
      rowsPerPageOptions={[5, 10, 15, 20, 25]}
    />
  );
};

export default GroupRankingDetailsTable;
